import {MentionResponse} from '../mention';

export class Project {
  id: number;
  advertiserId: number;
  countries: number[];
  keywords: MentionResponse[];
  name: string;
}



// WEBPACK FOOTER //
// ./src/models/project/project.ts